import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import * as React from 'react'

Bugsnag.start({
  apiKey: '0b0dd7f43d0c495fc4851ff651ccf5c1',
  releaseStage: 'none',
  autoDetectErrors: false,
  autoTrackSessions: false,
  enabledReleaseStages: [],
  plugins: [new BugsnagPluginReact()],
})

export const bugsnagClient = Bugsnag

const reactPlugin = Bugsnag.getPlugin('react')!
export const BugsnagErrorBoundary = reactPlugin.createErrorBoundary(React)
